import { Pipe, PipeTransform } from '@angular/core';
import { marked } from 'marked';

/**
 * Renders assistant Markdown to HTML for the chat bubble. The result is bound via [innerHTML],
 * which runs Angular's HTML sanitizer (scripts, event handlers and unsafe URLs are stripped),
 * so we never bypass security trust here. Pure pipe → parsed once per unique message.
 */
@Pipe({ name: 'aiChatMarkdown', standalone: false, pure: true })
export class FiAiChatMarkdownPipe implements PipeTransform {
    transform(value: string | null | undefined): string {
        if (!value) return '';
        // gfm + breaks: GitHub-style lists/formatting, and single newlines become <br>.
        return marked.parse(value, { gfm: true, breaks: true, async: false }) as string;
    }
}
